import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconCheck = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#Icon_Check_svg__a)"><path fill="currentColor" d="M62.32.773a3.974 3.974 0 0 0-5.573.907L19.333 53.867 6.827 41.36a4 4 0 0 0-5.654 5.653l15.814 15.84a4.08 4.08 0 0 0 6.08-.506l40.186-56A3.974 3.974 0 0 0 62.32.773" /></g>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="Icon_Check_svg__a"><path fill="currentColor" d="M0 0h64v64H0z" /></clipPath></defs>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconCheck.displayName = 'IconCheck';